import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResumeService } from '@app/core/services/resume.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize, switchMap } from 'rxjs/operators';
import { MyCvsFacade } from '../my-cvs/facades/my-cvs.facade';
import { UploadStatusModalComponent } from './modals/upload-status-modal/upload-status-modal.component';

@Component({
  selector: 'app-upload-cv',
  templateUrl: './upload-cv.component.html',
  styleUrls: ['./upload-cv.component.scss']
})
export class UploadCvComponent {

  @ViewChild('fileDropRef', { static: true }) fileDropRef: ElementRef;

  isPDFFileUploading = false;

  constructor(
    private myCvsFacade: MyCvsFacade,
    private snackBar: MatSnackBar,
    private resumeService: ResumeService,
    private translator: TranslateService,
    public dialog: MatDialog) { }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  prepareFilesList(file: File) {
    this.isPDFFileUploading = true;
    const selectedFile = file[0];

    if (this.hasCorrectFormat(selectedFile.name) && Math.round((selectedFile.size / 1024)) < 8192) {
      const uploadStatusModalRef = this.dialog.open(UploadStatusModalComponent, {
        disableClose: true,
        data: {
          message: `Uploading ${selectedFile.name}`,
        },
      });

      uploadStatusModalRef.afterOpened().pipe(
        switchMap(() => {
          return this.resumeService.uploadResume(selectedFile);
        }),
        finalize(() => {
          uploadStatusModalRef.close();
          this.isPDFFileUploading = false;
        })
      ).subscribe(() => {
        this.snackBar.open(`${selectedFile.name}: ${this.translator.instant('upload_cv.file_upload_cv_success')}`, null, {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: ['snackbar', 'snackbar-success']
        });

        this.myCvsFacade.loadMyCvs();
      }, () => {
        this.snackBar.open(this.translator.instant('api_errors.something_went_wrong'), null, {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: ['snackbar', 'snackbar-primary']
        });
      });

    } else {
      this.snackBar.open(this.translator.instant('upload_cv.file_upload_restriction_message'), null, {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: ['snackbar', 'snackbar-primary']
      });
      this.isPDFFileUploading = false;
    }

    this.fileDropRef.nativeElement.value = null;
  }

  hasCorrectFormat(fileName: string) {
    return fileName.endsWith('.pdf') ||
      fileName.endsWith('.doc') ||
      fileName.endsWith('.docx') ||
      fileName.endsWith('.jpg') ||
      fileName.endsWith('.jpeg');
  }
}
